export class Order
{
	orderId: number;
	orderDate: Date;
}
